import(/* webpackMode: "eager" */ "/opt/build/repo/app/events/page.tsx");
